import clx from 'classnames'
import styles from './TableAction.css'

const TableAction = props => {
  const {
    leftContent,
    children,
    className
  } = props
  return (
    <div className={clx(styles.TableAction, className)}>
      <div className={styles.leftContent}>
        {leftContent}
      </div>
      {children}
    </div>
  )
}

export default TableAction
